/**
 * Convert query builder results to CSV format
 */
export function convertToCSV(results: { rows: Record<string, any>[] }): string {
    if (!results.rows || results.rows.length === 0) {
        return '';
    }

    // Get headers from first row keys
    const headers = Object.keys(results.rows[0]);
    const csvRows: string[] = [];

    // Add header row
    csvRows.push(headers.join(','));

    // Add data rows
    for (const row of results.rows) {
        const values = headers.map(header => {
            const value = row[header];

            // Handle null/undefined
            if (value === null || value === undefined) {
                return '';
            }

            // Convert to string
            let valueStr = String(value);

            // Handle dates
            if (value instanceof Date) {
                valueStr = value.toISOString();
            }

            // Escape quotes and wrap in quotes if necessary
            const escaped = valueStr.replace(/"/g, '""');

            // Wrap in quotes if contains comma, newline, or quotes
            if (escaped.includes(',') || escaped.includes('\n') || escaped.includes('"')) {
                return `"${escaped}"`;
            }

            return escaped;
        });

        csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
}

/**
 * Trigger browser download of CSV data
 */
export function downloadCSV(csv: string, filename: string): void {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
